import { categories } from './categories'
import { students } from './students'

export const handlers = [
    ...categories,
    ...students
]
